exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.iframe_box[data-v-cdb7a4a4]{width:100%;height:100%;margin:0;padding:0;display:block\n}\n", "", {"version":3,"sources":["/data/data/jenkins/workspace/edu-gxzx-web-pro-new-study/src/components/views/iframe/iframe.vue"],"names":[],"mappings":";AAYA,6BACG,WACA,YACA,SACA,UACA,aAAc;CAChB","file":"iframe.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n.iframe_box{\n   width: 100%;\n   height: 100%;\n   margin: 0;\n   padding: 0;\n   display: block;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-cdb7a4a4","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/iframe/iframe.vue
// module id = OlU5
// module chunks = 96